<div class="content">
  <div class="container-fluid">
    <div class="page-title">
      <h1>
        <a href="javascript:void(0);" (click)="goBack()" class="back">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
        </a>
        {{'Device Status' | translate}}
      </h1>
    </div>
    <div class="index-content {{pageContentStatus.status}}">
      <!-- Detail -->
      <div class="content-detail {{pageContentStatus.status}}">
        <div class="device-detail-img" *ngIf="!powerMaster">
          <img [hidden]="loading" (load)="loading=false;" src="{{pageContentStatus.image}}" class="responsive-image">
          <img *ngIf="loading" src="/assets/images/default_device_lg.png" alt="loading" class="responsive-image">
        </div>
        <div class="detail-info clearfix">
          <div class="device-name">
            <div class="device-title">
              <!-- <i class="fa {{pageContentStatus.icon}}" aria-hidden="true"></i> -->
              <i class="fa fa-exclamation-triangle" aria-hidden="true" *ngIf="pageContentStatus.hardwarefault && pageContentStatus.hardwarefault.isHardwareFault"></i>
              <h5>{{pageContentStatus.name}}</h5>
            </div>
            <div class="device-detail-info">
              {{pageContentStatus.desc | translate}}
            </div>
          </div>
          <div class="button float-right flex">
            <div *ngIf="displayUPSControl && upsControl" class="upsControl">
              <p-button class="rounded ctrl-enabled" *ngIf="buttonStatus === 1" (click)="showCloudControlTurnOffDialog();">
                <div class="icon critical"><i class="fa fa-power-off" aria-hidden="true"></i></div>
                <div class="text" translate>Turn Off</div>
              </p-button>
              <p-button class="rounded ctrl-enabled" *ngIf="buttonStatus === 2" (click)="showCloudControlTurnOnDialog();">
                <div class="icon normal"><i class="fa fa-power-off" aria-hidden="true"></i></div>
                <div class="text" translate>Turn On</div>
              </p-button>
            </div>
            <div *ngIf="displayUPSControl && !upsControl" class="upsControl">
              <p-button class="rounded ctrl-disabled" (click)="showAlertCloudControlDisabledDisplayDialog();">
                <div class="icon offline"><i class="fa fa-power-off" aria-hidden="true"></i></div>
                <div class="text" *ngIf="buttonStatus === 1" translate>Turn Off</div>
                <div class="text" *ngIf="buttonStatus === 2" translate>Turn On</div>
              </p-button>
            </div>
            <p-button *ngIf="!pageContentStatus.is_shared && !disableSetting" icon="fa fa-cog" (click)="showDisplayDialog();"></p-button>
          </div>
        </div>
        <div class="status-info" [ngClass]="{'errorCode': hasErrorCode}">
          <div class="row" *ngIf="pageContentStatus.subtype === 'UPS' || pageContentStatus.subtype === '3-Phase UPS'">
            <div class="status-info-list" *ngIf="pageContentStatus.hardwarefault && pageContentStatus.hardwarefault.isHardwareFault">
              <div class="infoBox">
                <div class="icon errorCodeIcon">
                  <!-- <span>H</span> -->
                  <i class="fa fa-exclamation-triangle" aria-hidden="true" [ngStyle]="{'color': pageContentStatus.hardwarefault.faultLevelColor}"></i>
                </div>
                <div class="info">
                  <p translate>Hardware Status</p>
                  <h6>
                    <span>{{pageContentStatus.hardwarefault.faultCodeStr}}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list" *ngIf="pageContentStatus.subtype !== '3-Phase UPS'">
              <div class="infoBox">
                <div class="icon">
                  <i class="fa fa-plug" aria-hidden="true"></i>
                </div>
                <div class="info">
                  <p translate>Power source</p>
                  <h6>
                    <span *ngIf="(deviceDetails$ | async)?.PowSour else noData_span">{{(deviceDetails$ | async)?.PowSour | translate}}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list">
              <div class="infoBox">
                <div class="icon battery" [ngClass]="{'alert-color': (batteryReplacementInfo.expires)}">
                  <p-progressbar [value]="(deviceDetails$ | async)?.BatCap" [showValue]="false"></p-progressbar>
                  <i class="fa fa-battery-empty" aria-hidden="true"></i>
                </div>
                <div class="info">
                  <p translate>Battery Capacity</p>
                  <h6>
                    <span *ngIf="((deviceDetails$ | async)?.BatCap !== null && (deviceDetails$ | async)?.BatCap !== undefined) else noData_span">{{(deviceDetails$ | async)?.BatCap}} %</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list" *ngIf="pageContentStatus.subtype !== '3-Phase UPS'">
              <div class="infoBox">
                <div class="icon">
                  <i class="fa fa-bolt" aria-hidden="true"></i>
                </div>
                <div class="info">
                  <p translate>Output Voltage</p>
                  <h6>
                    <span *ngIf="(deviceDetails$ | async)?.OutVolt else noData_span">{{(deviceDetails$ | async)?.OutVolt}} {{'volts' | translate}}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list" *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
              <div class="infoBox">
                <div class="icon">
                  <i class="fa fa-bolt" aria-hidden="true"></i>
                </div>
                <div class="info">
                  <p translate>Output Voltage-A/B/C</p>
                  <h6>
                    <span *ngIf="((deviceDetails$ | async)?.OutVoltA !== null && (deviceDetails$ | async)?.OutVoltA !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutVoltA}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.OutVoltB !== null && (deviceDetails$ | async)?.OutVoltB !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutVoltB}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.OutVoltC !== null && (deviceDetails$ | async)?.OutVoltC !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutVoltC}} {{'volts' | translate}}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list" *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
              <div class="infoBox">
                <div class="icon">
                  <i class="fa fa-line-chart" aria-hidden="true"></i>
                </div>
                <div class="info">
                  <p translate>UPS Load-A/B/C</p>
                  <h6>
                    <span *ngIf="((deviceDetails$ | async)?.LoadPctA !== null && (deviceDetails$ | async)?.LoadPctA !== undefined) else noData_span">{{(deviceDetails$ | async)?.LoadPctA}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.LoadPctB !== null && (deviceDetails$ | async)?.LoadPctB !== undefined) else noData_span">{{(deviceDetails$ | async)?.LoadPctB}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.LoadPctC !== null && (deviceDetails$ | async)?.LoadPctC !== undefined) else noData_span">{{(deviceDetails$ | async)?.LoadPctC}} %</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list" *ngIf="pageContentStatus.sourcetype !== SourceType['Gateway']">
              <div class="infoBox">
                <div class="icon">
                  <i class="fa fa-clock-o" aria-hidden="true"></i>
                </div>
                <div class="info">
                  <p translate>Estimated Time</p>
                  <h6>
                    <span *ngIf="(deviceDetails$ | async)?.BatRun else noData_span">{{(deviceDetails$ | async)?.BatRun}} {{'minutes' | translate}}</span>
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="pageContentStatus.subtype !== 'UPS' && pageContentStatus.subtype !== '3-Phase UPS'">
            <div class="status-info-list" *ngIf="pageContentStatus.hardwarefault && pageContentStatus.hardwarefault.isHardwareFault">
              <div class="infoBox">
                <div class="icon errorCodeIcon">
                  <!-- <span>H</span> -->
                  <i class="fa fa-exclamation-triangle" aria-hidden="true" [ngStyle]="{'color': pageContentStatus.hardwarefault.faultLevelColor}"></i>
                </div>
                <div class="info">
                  <p translate>Hardware Status</p>
                  <h6>
                    <span>{{pageContentStatus.hardwarefault.faultCodeStr}}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list" *ngIf="pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU'">
              <div class="infoBox">
                <div class="icon">
                  <span class="material-icons">
                    lightbulb
                  </span>
                </div>
                <div class="info">
                  <p translate>Total Power</p>
                  <h6>
                    <span *ngIf="((deviceDetails$ | async)?.PowerT !== null && (deviceDetails$ | async)?.PowerT !== undefined) else noData_span">{{(deviceDetails$ | async)?.PowerT}} {{'W' | translate}}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list" *ngIf="pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU'">
              <div class="infoBox">
                <div class="icon">
                  <span class="material-icons">
                    model_training
                  </span>
                </div>
                <div class="info">
                  <p translate>Total Energy</p>
                  <h6>
                    <span *ngIf="((deviceDetails$ | async)?.EnergyT !== null && (deviceDetails$ | async)?.EnergyT !== undefined) else noData_span">{{(deviceDetails$ | async)?.EnergyT}} {{'kWh' | translate}}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list">
              <div class="infoBox">
                <div class="icon">
                  <i class="fa fa-bolt" aria-hidden="true"></i>
                </div>
                <div class="info">
                  <p translate>Current</p>
                  <h6>
                    <span *ngIf="((deviceDetails$ | async)?.Cur !== null && (deviceDetails$ | async)?.Cur !== undefined) else noData_span">{{(deviceDetails$ | async)?.Cur | translate}} {{'A' | translate}}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list" *ngIf="pageContentStatus.subtype === 'PDU'">
              <div class="infoBox">
                <div class="icon">
                  <i class="fa fa-plug" aria-hidden="true"></i>
                </div>
                <div class="info">
                  <p translate>Voltage</p>
                  <h6>
                    <span *ngIf="((deviceDetails$ | async)?.Volt !== null && (deviceDetails$ | async)?.Volt !== undefined) else noData_span">{{(deviceDetails$ | async)?.Volt}} {{'volts' | translate}}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list" *ngIf="pageContentStatus.subtype === 'ATS' || pageContentStatus.subtype === 'PDU'">
              <div class="infoBox">
                <div class="icon">
                  <span class="material-icons">
                    lightbulb
                  </span>
                </div>
                <div class="info">
                  <p translate>Power</p>
                  <h6>
                    <span *ngIf="((deviceDetails$ | async)?.Power !== null && (deviceDetails$ | async)?.Power !== undefined) else noData_span">{{(deviceDetails$ | async)?.Power}} {{'W' | translate}}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list" *ngIf="pageContentStatus.subtype === 'ATS' || pageContentStatus.subtype === 'PDU'">
              <div class="infoBox">
                <div class="icon">
                  <span class="material-icons">
                    model_training
                  </span>
                </div>
                <div class="info">
                  <p translate>Energy</p>
                  <h6>
                    <span *ngIf="((deviceDetails$ | async)?.Energy !== null && (deviceDetails$ | async)?.Energy !== undefined) else noData_span">{{(deviceDetails$ | async)?.Energy}} {{'kWh' | translate}}</span>
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="page-title flex" *ngIf="pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU'">
        <h5 class="float-left">{{'Host' | translate}}</h5>
      </div>
      <div class="row">
        <!-- Current Status -->
        <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
          <div class="content-info">
            <div class="content-title">
              <h5 translate>Current Status</h5>
            </div>
            <div class="content-body">
              <ul class="info-list">
                <li *ngIf="pageContentStatus.subtype === 'UPS' || pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Electrical power supplied by</div>
                  <div class="value">
                    <span *ngIf="(deviceDetails$ | async)?.PowSour else noData_span">{{(deviceDetails$ | async)?.PowSour | translate}}</span>
                  </div>
                </li>
                <!-- db無此欄位, 詢問pm後拿掉, 2025/2/19 kyrie -->
                <!-- <li *ngIf="pageContentStatus.subtype === 'UPS' || (pageContentStatus.subtype === '3-Phase UPS' && pageContentStatus.sourcetype !== SourceType['Gateway'])">
                  <div translate class="title">Output Energy</div>
                  <div class="value">
                    <span *ngIf="(deviceDetails$ | async)?.OutEnergy else noData_span">{{(deviceDetails$ | async)?.OutEnergy}}</span>
                  </div>
                </li> -->
                <li *ngIf="pageContentStatus.subtype === 'UPS'">
                  <div translate class="title">Output Voltage</div>
                  <div class="value">
                    <span *ngIf="(deviceDetails$ | async)?.OutVolt else noData_span">{{(deviceDetails$ | async)?.OutVolt}} {{'volts' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'UPS' || pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Output Status</div>
                  <div class="value">
                    <span *ngIf="(deviceDetails$ | async)?.OutSta else noData_span">{{(deviceDetails$ | async)?.OutSta | translate}}</span>
                  </div>
                </li>
                <li *ngIf="(deviceDetails$ | async)?.IsConnectedCard && pageContentStatus.subtype === 'UPS' || pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Input Status</div>
                  <div class="value">
                    <span *ngIf="(deviceDetails$ | async)?.InSta else noData_span">{{(deviceDetails$ | async)?.InSta | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Bypass Voltage-A/B/C</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.BpsVoltA !== null && (deviceDetails$ | async)?.BpsVoltA !== undefined) else noData_span">{{(deviceDetails$ | async)?.BpsVoltA | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.BpsVoltB !== null && (deviceDetails$ | async)?.BpsVoltB !== undefined) else noData_span">{{(deviceDetails$ | async)?.BpsVoltB | translate}} </span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.BpsVoltB !== null && (deviceDetails$ | async)?.BpsVoltC !== undefined) else noData_span">{{(deviceDetails$ | async)?.BpsVoltC | translate}} {{'volts' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Bypass Current-A/B/C</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.BpsCurA !== null && (deviceDetails$ | async)?.BpsCurA !== undefined) else noData_span">{{(deviceDetails$ | async)?.BpsCurA | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.BpsCurB !== null && (deviceDetails$ | async)?.BpsCurB !== undefined) else noData_span">{{(deviceDetails$ | async)?.BpsCurB | translate}} </span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.BpsCurB !== null && (deviceDetails$ | async)?.BpsCurC !== undefined) else noData_span">{{(deviceDetails$ | async)?.BpsCurC | translate}} {{'A' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Bypass Power Factor-A/B/C</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.BpsPFA !== null && (deviceDetails$ | async)?.BpsPFA !== undefined) else noData_span">{{(deviceDetails$ | async)?.BpsPFA | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.BpsPFB !== null && (deviceDetails$ | async)?.BpsPFB !== undefined) else noData_span">{{(deviceDetails$ | async)?.BpsPFB | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.BpsPFB !== null && (deviceDetails$ | async)?.BpsPFC !== undefined) else noData_span">{{(deviceDetails$ | async)?.BpsPFC | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Input Power Factor-A/B/C</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.InPFA !== null && (deviceDetails$ | async)?.InPFA !== undefined) else noData_span">{{(deviceDetails$ | async)?.InPFA | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.InPFB !== null && (deviceDetails$ | async)?.InPFB !== undefined) else noData_span">{{(deviceDetails$ | async)?.InPFB | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.InPFB !== null && (deviceDetails$ | async)?.InPFC !== undefined) else noData_span">{{(deviceDetails$ | async)?.InPFC | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'ATS'">
                  <div translate class="title">Source</div>
                  <div class="value">
                    <span *ngIf="(deviceDetails$ | async)?.Source else noData_span">{{(deviceDetails$ | async)?.Source | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'ATS' || pageContentStatus.subtype === 'PDU'">
                  <div translate class="title">Current</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.Cur !== null && (deviceDetails$ | async)?.Cur !== undefined) else noData_span">{{(deviceDetails$ | async)?.Cur}} {{'A' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'PDU'">
                  <div translate class="title">Voltage</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.Volt !== null && (deviceDetails$ | async)?.Volt !== undefined) else noData_span">{{(deviceDetails$ | async)?.Volt}} {{'volts' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'ATS'">
                  <div translate class="title">Input Status-A</div>
                  <div class="value">
                    <span *ngIf="(deviceDetails$ | async)?.InStaA else noData_span">{{(deviceDetails$ | async)?.InStaA | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'ATS'">
                  <div translate class="title">Input Voltage-A</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.InVoltA !== null && (deviceDetails$ | async)?.InVoltA !== undefined) else noData_span">{{(deviceDetails$ | async)?.InVoltA}} {{'volts' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'ATS'">
                  <div translate class="title">Input Status-B</div>
                  <div class="value">
                    <span *ngIf="(deviceDetails$ | async)?.InStaB else noData_span">{{(deviceDetails$ | async)?.InStaB | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'ATS'">
                  <div translate class="title">Input Voltage-B</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.InVoltB !== null && (deviceDetails$ | async)?.InVoltB !== undefined) else noData_span">{{(deviceDetails$ | async)?.InVoltB}} {{'volts' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Input Voltage-A/B/C</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.InVoltA !== null && (deviceDetails$ | async)?.InVoltA !== undefined) else noData_span">{{(deviceDetails$ | async)?.InVoltA | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.InVoltB !== null && (deviceDetails$ | async)?.InVoltB !== undefined) else noData_span">{{(deviceDetails$ | async)?.InVoltB | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.InVoltB !== null && (deviceDetails$ | async)?.InVoltC !== undefined) else noData_span">{{(deviceDetails$ | async)?.InVoltC | translate}} {{'volts' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Input Current-A/B/C</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.InCurA !== null && (deviceDetails$ | async)?.InCurA !== undefined) else noData_span">{{(deviceDetails$ | async)?.InCurA | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.InCurB !== null && (deviceDetails$ | async)?.InCurB !== undefined) else noData_span">{{(deviceDetails$ | async)?.InCurB | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.InCurB !== null && (deviceDetails$ | async)?.InCurC !== undefined) else noData_span">{{(deviceDetails$ | async)?.InCurC | translate}} {{'A' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Output Voltage-A/B/C</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.OutVoltA !== null && (deviceDetails$ | async)?.OutVoltA !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutVoltA | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.OutVoltB !== null && (deviceDetails$ | async)?.OutVoltB !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutVoltB | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.OutVoltB !== null && (deviceDetails$ | async)?.OutVoltC !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutVoltC | translate}} {{'volts' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Output Current-A/B/C</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.OutCurA !== null && (deviceDetails$ | async)?.OutCurA !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutCurA | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.OutCurB !== null && (deviceDetails$ | async)?.OutCurB !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutCurB | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.OutCurB !== null && (deviceDetails$ | async)?.OutCurC !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutCurC | translate}} {{'A' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Output Apparent Power-A/B/C</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.OutAppA !== null && (deviceDetails$ | async)?.OutAppA !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutAppA | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.OutAppB !== null && (deviceDetails$ | async)?.OutAppB !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutAppB | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.OutAppB !== null && (deviceDetails$ | async)?.OutAppC !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutAppC | translate}} {{'kVA' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Output Active Power-A/B/C</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.OutPwA !== null && (deviceDetails$ | async)?.OutPwA !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutPwA | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.OutPwB !== null && (deviceDetails$ | async)?.OutPwB !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutPwB | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.OutPwB !== null && (deviceDetails$ | async)?.OutPwC !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutPwC | translate}} {{'kW' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Output Reactive Power-A/B/C</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.OutRctA !== null && (deviceDetails$ | async)?.OutRctA !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutRctA | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.OutRctB !== null && (deviceDetails$ | async)?.OutRctB !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutRctB | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.OutRctB !== null && (deviceDetails$ | async)?.OutRctC !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutRctC | translate}} {{'kVar' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'ATS' || pageContentStatus.subtype === 'PDU' || pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU'">
                  <div translate class="title" *ngIf="pageContentStatus.subtype === 'ATS' || pageContentStatus.subtype === 'PDU'">Power</div>
                  <div translate class="title" *ngIf="pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU'">Total Power</div>
                  <div class="value" *ngIf="pageContentStatus.subtype === 'ATS' || pageContentStatus.subtype === 'PDU'">
                    <span *ngIf="((deviceDetails$ | async)?.Power !== null && (deviceDetails$ | async)?.Power !== undefined) else noData_span">{{(deviceDetails$ | async)?.Power}} {{'W' | translate}}</span>
                  </div>
                  <div class="value" *ngIf="pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU'">
                    <span *ngIf="((deviceDetails$ | async)?.PowerT !== null && (deviceDetails$ | async)?.PowerT !== undefined) else noData_span">{{(deviceDetails$ | async)?.PowerT}} {{'W' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU'">
                  <div translate class="title">Total Energy</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.EnergyT !== null && (deviceDetails$ | async)?.EnergyT !== undefined) else noData_span">{{(deviceDetails$ | async)?.EnergyT}} {{'kWh' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU'">
                  <div translate class="title">Current</div>
                  <div class="value"><span *ngIf="((deviceDetails$ | async)?.Cur !== null && (deviceDetails$ | async)?.Cur !== undefined) else noData_span">{{(deviceDetails$ | async)?.Cur}} {{'A' | translate}}</span></div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU'">
                  <div translate class="title">Current-A</div>
                  <div class="value"><span *ngIf="((deviceDetails$ | async)?.CurA !== null && (deviceDetails$ | async)?.CurA !== undefined) else noData_span">{{(deviceDetails$ | async)?.CurA}} {{'A' | translate}}</span></div>
                </li>
                <li *ngIf="((deviceDetails$ | async)?.CurB !== null && (deviceDetails$ | async)?.CurB !== undefined) && (pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU')">
                  <div translate class="title">Current-B</div>
                  <div class="value"><span>{{(deviceDetails$ | async)?.CurB}} {{'A' | translate}}</span></div>
                </li>
                <li *ngIf="((deviceDetails$ | async)?.CurC !== null && (deviceDetails$ | async)?.CurC !== undefined) && (pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU')">
                  <div translate class="title">Current-C</div>
                  <div class="value"><span>{{(deviceDetails$ | async)?.CurC}} {{'A' | translate}}</span></div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU'">
                  <div translate class="title">Peak Current</div>
                  <div class="value"><span *ngIf="((deviceDetails$ | async)?.PkCur !== null && (deviceDetails$ | async)?.PkCur !== undefined) else noData_span">{{(deviceDetails$ | async)?.PkCur}} {{'A' | translate}}</span></div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU'">
                  <div translate class="title">Peak Current-A</div>
                  <div class="value"><span *ngIf="((deviceDetails$ | async)?.PkCurA !== null && (deviceDetails$ | async)?.PkCurA !== undefined) else noData_span">{{(deviceDetails$ | async)?.PkCurA}} {{'A' | translate}}</span></div>
                </li>
                <li *ngIf="((deviceDetails$ | async)?.PkCurB !== null && (deviceDetails$ | async)?.PkCurB !== undefined) && (pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU')">
                  <div translate class="title">Peak Current-B</div>
                  <div class="value"><span>{{(deviceDetails$ | async)?.PkCurB}} {{'A' | translate}}</span></div>
                </li>
                <li *ngIf="((deviceDetails$ | async)?.PkCurC !== null && (deviceDetails$ | async)?.PkCurC !== undefined) && (pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU')">
                  <div translate class="title">Peak Current-C</div>
                  <div class="value"><span>{{(deviceDetails$ | async)?.PkCurC}} {{'A' | translate}}</span></div>
                </li>
                <!-- 收資料 但不顯示 2025/02/19 kyrie -->
                <!-- <li *ngIf="(deviceDetails$ | async)?.PkTs && (pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU')">
                  <div translate class="title">Peak Time</div>
                  <div class="value"><span *ngIf="(deviceDetails$ | async)?.PkTs else noData_span">{{(deviceDetails$ | async)?.PkTs}}</span></div>
                </li> -->
                <li *ngIf="pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU'">
                  <div translate class="title">Voltage-A</div>
                  <div class="value"><span *ngIf="((deviceDetails$ | async)?.VoltA !== null && (deviceDetails$ | async)?.VoltA !== undefined) else noData_span">{{(deviceDetails$ | async)?.VoltA}} {{'volts' | translate}}</span></div>
                </li>
                <li *ngIf="((deviceDetails$ | async)?.VoltB !== null && (deviceDetails$ | async)?.VoltB !== undefined) && (pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU')">
                  <div translate class="title">Voltage-B</div>
                  <div class="value"><span>{{(deviceDetails$ | async)?.VoltB}} {{'volts' | translate}}</span></div>
                </li>
                <li *ngIf="((deviceDetails$ | async)?.VoltC !== null && (deviceDetails$ | async)?.VoltC !== undefined) && (pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU')">
                  <div translate class="title">Voltage-C</div>
                  <div class="value"><span>{{(deviceDetails$ | async)?.VoltC}} {{'volts' | translate}}</span></div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'ATS' || pageContentStatus.subtype === 'PDU' || pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU'">
                  <div translate class="title">Energy</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.Energy !== null && (deviceDetails$ | async)?.Energy !== undefined) else noData_span">{{(deviceDetails$ | async)?.Energy}} {{'kWh' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Output Power Factor-A/B/C</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.OutPFA !== null && (deviceDetails$ | async)?.OutPFA !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutPFA | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.OutPFB !== null && (deviceDetails$ | async)?.OutPFB !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutPFB | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.OutPFB !== null && (deviceDetails$ | async)?.OutPFC !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutPFC | translate}}</span>
                  </div>
                </li>
                <li *ngIf="((deviceDetails$ | async)?.SelSrc !== null && (deviceDetails$ | async)?.SelSrc !== undefined) && (pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU')">
                  <div translate class="title">Selected Source</div>
                  <div class="value">
                    <span>{{(deviceDetails$ | async)?.SelSrc | translate}}</span>
                  </div>
                </li>
                <li *ngIf="((deviceDetails$ | async)?.PreSrc !== null && (deviceDetails$ | async)?.PreSrc !== undefined) && (pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU')">
                  <div translate class="title">Prefered Source</div>
                  <div class="value">
                    <span>{{(deviceDetails$ | async)?.PreSrc | translate}}</span>
                  </div>
                </li>
                <li *ngIf="((deviceDetails$ | async)?.SrcVoltA !== null && (deviceDetails$ | async)?.SrcVoltA !== undefined) && (pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU')">
                  <div translate class="title">Source Voltage-A</div>
                  <div class="value">
                    <span>{{(deviceDetails$ | async)?.SrcVoltA}} {{'volts' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="((deviceDetails$ | async)?.SrcVoltB !== null && (deviceDetails$ | async)?.SrcVoltB !== undefined) && (pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU')">
                  <div translate class="title">Source Voltage-B</div>
                  <div class="value">
                    <span>{{(deviceDetails$ | async)?.SrcVoltB}} {{'volts' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="((deviceDetails$ | async)?.SrcFreqA !== null && (deviceDetails$ | async)?.SrcFreqA !== undefined) && (pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU')">
                  <div translate class="title">Source Frequency-A</div>
                  <div class="value">
                    <span>{{(deviceDetails$ | async)?.SrcFreqA}} {{'Hz' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="((deviceDetails$ | async)?.SrcFreqB !== null && (deviceDetails$ | async)?.SrcFreqB !== undefined) && (pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU')">
                  <div translate class="title">Source Frequency-B</div>
                  <div class="value">
                    <span>{{(deviceDetails$ | async)?.SrcFreqB}} {{'Hz' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="((deviceDetails$ | async)?.SrcStaA !== null && (deviceDetails$ | async)?.SrcStaA !== undefined) && (pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU')">
                  <div translate class="title">Source Status-A</div>
                  <div class="value">
                    <span>{{(deviceDetails$ | async)?.SrcStaA | translate}}</span>
                  </div>
                </li>
                <li *ngIf="((deviceDetails$ | async)?.SrcStaB !== null && (deviceDetails$ | async)?.SrcStaB !== undefined) && (pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU')">
                  <div translate class="title">Source Status-B</div>
                  <div class="value">
                    <span>{{(deviceDetails$ | async)?.SrcStaB | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'UPS'">
                  <div translate class="title">UPS Load</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.Load !== null && (deviceDetails$ | async)?.Load !== undefined) else noData_span">{{(deviceDetails$ | async)?.Load}} {{'watts' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'UPS'">
                  <div translate class="title">UPS Load(%)</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.LoadPct !== null && (deviceDetails$ | async)?.LoadPct !== undefined) else noData_span">{{(deviceDetails$ | async)?.LoadPct}} %</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">UPS Load-A/B/C(%)</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.LoadPctA !== null && (deviceDetails$ | async)?.LoadPctA !== undefined) else noData_span">{{(deviceDetails$ | async)?.LoadPctA | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.LoadPctB !== null && (deviceDetails$ | async)?.LoadPctB !== undefined) else noData_span">{{(deviceDetails$ | async)?.LoadPctB | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.LoadPctB !== null && (deviceDetails$ | async)?.LoadPctC !== undefined) else noData_span">{{(deviceDetails$ | async)?.LoadPctC | translate}} %</span>
                  </div>
                </li>
                <li *ngIf="((deviceDetails$ | async)?.SysTemp !== null && (deviceDetails$ | async)?.SysTemp !== undefined) && (pageContentStatus.subtype === 'UPS' || pageContentStatus.subtype === '3-Phase UPS')">
                  <div translate class="title">UPS Temperature</div>
                  <div class="value">
                    <span>{{(preferenceService.tempUnit === '℉' && (deviceDetails$ | async)?.SysTemp) ? (((deviceDetails$ | async)?.SysTemp * 1.8) + 32).toFixed(1) : (deviceDetails$ |
                      async)?.SysTemp}}
                      ({{preferenceService.tempUnit}})</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- Battery Info -->
        <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12" *ngIf="pageContentStatus.subtype === 'UPS' || pageContentStatus.subtype === '3-Phase UPS'">
          <div class="content-info">
            <div class="content-title battery">
              <h5 translate>Battery Info</h5>
            </div>
            <div class="content-body">
              <ul class="info-list">
                <li>
                  <div translate class="title">Remaining Battery Capacity</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.BatCap !== null && (deviceDetails$ | async)?.BatCap !== undefined) else noData_span">{{(deviceDetails$ | async)?.BatCap}} %</span>
                  </div>
                </li>
                <li>
                  <div translate class="title">Battery Status</div>
                  <div class="value">
                    <span *ngIf="(deviceDetails$ | async)?.BatSta else noData_span">{{(deviceDetails$ | async)?.BatSta | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Battery Voltage v1</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.BatVolt !== null && (deviceDetails$ | async)?.BatVolt !== undefined) else noData_span">{{(deviceDetails$ | async)?.BatVolt}} {{'volts' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Battery Voltage v2</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.BatVoltB !== null && (deviceDetails$ | async)?.BatVoltB !== undefined) else noData_span">{{(deviceDetails$ | async)?.BatVoltB}} {{'volts' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Battery Current c1</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.BatCurA !== null && (deviceDetails$ | async)?.BatCurA !== undefined) else noData_span">{{(deviceDetails$ | async)?.BatCurA}} {{'A' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Battery Current c2</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.BatCurB !== null && (deviceDetails$ | async)?.BatCurB !== undefined) else noData_span">{{(deviceDetails$ | async)?.BatCurB}} {{'A' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Remaining Battery Runtime</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.BatRun !== null && (deviceDetails$ | async)?.BatRun !== undefined) else noData_span">{{(deviceDetails$ | async)?.BatRun}} {{'minutes' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Battery Temperature</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.BatTemp !== null && (deviceDetails$ | async)?.BatTemp !== undefined) else noData_span">{{(preferenceService.tempUnit === '℉' && (deviceDetails$ | async)?.BatTemp) ? (((deviceDetails$ | async)?.BatTemp * 1.8) + 32).toFixed(1) : (deviceDetails$ |
                      async)?.BatTemp}}
                      ({{preferenceService.tempUnit}})</span>
                  </div>
                </li>
                <!-- <li *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Module Amount</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.ModNum !== null && (deviceDetails$ | async)?.ModNum !== undefined) else noData_span">{{(deviceDetails$ | async)?.ModNum}} %</span>
                  </div>
                </li> -->
                <li *ngIf="pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Battery Amount</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.BatNum !== null && (deviceDetails$ | async)?.BatNum !== undefined) else noData_span">{{(deviceDetails$ | async)?.BatNum}}</span>
                  </div>
                </li>
                <li *ngIf="!hideBHI" [ngClass]="{'margin-bottom': isBHIActivated}">
                  <div class="title">
                    <span translate>Battery Health</span>
                    <span class="icon" (click)="BHI.toggle($event)">
                      <i class="fa fa fa-info-circle" aria-hidden="true"></i>
                    </span>
                  </div>
                  <div class="value" *ngIf="isBHIActivated else Inactivate">
                    <!-- <span *ngIf="(deviceDetails$ | async)?.BHI> 0 else noData_span">{{(deviceDetails$ | async)?.BHI}} %</span> -->
                  </div>
                </li>
                <li class="progressBar {{(deviceDetails$ | async)?.BHIStatus}}" *ngIf="!hideBHI && isBHIActivated" disabled="disableBHI">
                  <div class="value" *ngIf="(deviceDetails$ | async)?.BHIStatus else noData_BHI">{{(deviceDetails$ | async)?.BHIStatus | translate}}</div>
                  <ng-template #noData_BHI>
                    <span class="value">N/A</span>
                  </ng-template>
                  <p-progressbar [value]="(deviceDetails$ | async)?.BHI" [showValue]="false"></p-progressbar>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'UPS'">
                  <div translate class="title">Remaining Battery Runtime</div>
                  <div class="value">
                    <span *ngIf="(deviceDetails$ | async)?.BatRun else noData_span">{{(deviceDetails$ | async)?.BatRun}} {{'minutes' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'UPS' || (pageContentStatus.subtype === '3-Phase UPS' && pageContentStatus.sourcetype !== SourceType['Gateway'])">
                  <div translate class="title">Battery Replacement Date</div>
                  <div class="value">
                    <span
                      *ngIf="batteryReplacementInfo && batteryReplacementInfo.BR_Date else noData_span">{{(pageContentStatus.region)* 60 * 60 * 1000 + batteryReplacementInfo.BR_Date * 1000 |
                      date: preferenceService.dateFormat}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'UPS' || (pageContentStatus.subtype === '3-Phase UPS' && pageContentStatus.sourcetype !== SourceType['Gateway'])">
                  <div translate class="title">Recommended Battery Replacement Date</div>
                  <div class="value" *ngIf="batteryReplacementInfo" [ngClass]="{'alert-color': batteryReplacementInfo.expires}">
                    <i class="fa fa-bell" aria-hidden="true" *ngIf="batteryReplacementInfo.expires"></i>
                    <span
                      *ngIf="batteryReplacementInfo && batteryReplacementInfo.BR_Date else noData_span">{{(pageContentStatus.region)* 60 * 60 * 1000 + batteryReplacementInfo.BR_Rc_Date | date:
                      preferenceService.dateFormat}}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- Profile -->
        <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
          <div class="content-info">
            <div class="content-title">
              <h5 translate>Profile</h5>
            </div>
            <div class="content-body">
              <ul class="info-list">
                <li>
                  <div translate class="title">Device Name</div>
                  <div class="value">
                    {{pageContentStatus.name}}
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU'">
                  <div class="title">{{'Sub Device' | translate}}</div>
                  <div class="value">{{'Host' | translate}}</div>
                </li>
                <li>
                  <div translate class="title">Description</div>
                  <div class="value">
                    {{pageContentStatus.deviceDescription}}
                  </div>
                </li>
                <li>
                  <div translate class="title">Time Zone</div>
                  <div class="value">
                    <span>{{pageContentStatus.region | utcFormat}}</span>
                  </div>
                </li>
                <li>
                  <div translate class="title">Model Name</div>
                  <div class="value">
                    <span *ngIf="(deviceDetails$ | async)?.Model else noData_span">{{(deviceDetails$ | async)?.Model}}</span>
                  </div>
                </li>
                <li class="serialNumber">
                  <div translate class="title">Serial Number</div>
                  <div class="value">{{sn?.substr(0, 25) || ''}}</div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'UPS' || pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Firmware Version</div>
                  <div class="value">
                    <span *ngIf="(deviceDetails$ | async)?.FV else noData_span">{{(deviceDetails$ | async)?.FV}}</span>
                  </div>
                </li>
                <li>
                  <div translate class="title">IP Address</div>
                  <div class="value">
                    <span *ngIf="pageContentStatus.DeviceIP else noData_span">{{pageContentStatus.DeviceIP}}</span>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'UPS' || pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Outlet Naming</div>
                  <div class="value">
                    <button pButton type="button" icon="fa fa-pencil-square-o" class="{{Confirm_button}}" (click)="showOutletNamingDisplayDialog()" [disabled]="pageContentStatus.status === 'offline' || pageContentStatus.is_shared"></button>
                  </div>
                </li>
                <li *ngIf="pageContentStatus.subtype === 'UPS' || pageContentStatus.subtype === '3-Phase UPS'">
                  <div translate class="title">Power Rating</div>
                  <div class="value">
                    <span *ngIf="((deviceDetails$ | async)?.RatPow && (deviceDetails$ | async)?.RatPow> 0) else noData_span">{{(deviceDetails$ | async)?.RatPow}} {{'VA' | translate}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.LP && (deviceDetails$ | async)?.LP> 0) else noData_span">{{(deviceDetails$ | async)?.LP}} {{'watts' | translate}}</span>
                  </div>
                </li>
                <li *ngIf="(deviceDetails$ | async)?.expirationDate && pageContentStatus.subtype === 'UPS'">
                  <div translate class="title">Trial Expiration Date</div>
                  <div class="value" [ngClass]="{'alert-color': (deviceDetails$ | async)?.TrialRemainDay <10}">
                    <span>
                      {{(deviceDetails$ | async)?.expirationDate | date: preferenceService.dateFormat}}
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- Battery Test  -->
        <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12" *ngIf="(pageContentStatus.subtype === 'UPS') && pageContentStatus.sourcetype !== SourceType['Gateway'] && pageContentStatus.status != 'offline' &&   batteryTestFeature && !isTrial">
          <div class="batteryTest">
            <p-blockUI [target]="bbt" [blocked]="batteryTestResult.blockUI" class="loading-blockUI">
              <div class="loading">
                <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
                <p translate>Wait for testing...</p>
              </div>
            </p-blockUI>
            <p-panel #bbt class="loading-panel">
              <div class="content-info">
                <div class="content-title">
                  <h5 translate>Battery Test</h5>
                  <div class="time">
                    <p-select [options]="timeOptions" [(ngModel)]="batteryTestWaitingTime" [style]="{'width':'100%'}"></p-select>
                  </div>
                  <button pButton type="button" label="{{'TEST' | translate}}" class="{{Confirm_button}}" (click)="batteryTest()" [disabled]="pageContentStatus.is_shared || disableBattery"></button>
                </div>
                <div class="content-body">
                  <ul class="info-list">
                    <li>
                      <div translate class="title">Last Test Result</div>
                      <div class="value">
                        <span>{{batteryTestResult.status | translate}}</span>
                      </div>
                    </li>
                    <li>
                      <div translate class="title">Last Test Date</div>
                      <div class="value">
                        <span>{{(batteryTestResult.date != null) ? ((batteryTestResult.date * 1000) + ((localTimeZone + pageContentStatus.region)* 60 * 60 * 1000) | date:
                          preferenceService.dateFormat +
                          ' HH:mm:ss') : '--'}}</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </p-panel>
          </div>
        </div>
      </div>
      <div class="panel-detail" *ngIf="pageContentStatus.subtype === 'nATS' || pageContentStatus.subtype === 'nPDU'">
          <p-tabs>
            <p-tabpanel [header]="item.SubDevice" *ngFor="let item of subDeviceDetail; let i = index" [selected]="i == 0">
              <div class="row">
                <!-- Current Status -->
                <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                  <div class="content-info">
                    <div class="content-title">
                      <h5 translate>Current Status</h5>
                    </div>
                    <div class="content-body">
                      <ul class="info-list">
                        <li>
                          <div class="title">{{'Total Power' | translate}}</div>
                          <div class="value"><span *ngIf="((deviceDetails$ | async)?.PowerT !== null && (deviceDetails$ | async)?.PowerT !== undefined) else noData_span">{{(deviceDetails$ | async)?.PowerT}} {{'W' | translate}}</span></div>
                        </li>
                        <li>
                          <div class="title">{{'Total Energy' | translate}}</div>
                          <div class="value"><span *ngIf="((deviceDetails$ | async)?.EnergyT !== null && (deviceDetails$ | async)?.EnergyT !== undefined) else noData_span">{{(deviceDetails$ | async)?.EnergyT}} {{'kWh' | translate}}</span></div>
                        </li>
                        <li>
                          <div class="title">{{'Current' | translate}}</div>
                          <div class="value"><span *ngIf="(item.Cur !== null && item.Cur !== undefined) else noData_span">{{item.Cur}} {{'A' | translate}}</span></div>
                        </li>
                        <li>
                          <div class="title">{{'Current-A' | translate}}</div>
                          <div class="value"><span *ngIf="(item.CurA !== null && item.CurA !== undefined) else noData_span">{{item.CurA}} {{'A' | translate}}</span></div>
                        </li>
                        <li *ngIf="(item.CurB !== null && item.CurB !== undefined)">
                          <div class="title">{{'Current-B' | translate}}</div>
                          <div class="value"><span>{{item.CurB}} {{'A' | translate}}</span></div>
                        </li>
                        <li *ngIf="(item.CurC !== null && item.CurC !== undefined)">
                          <div class="title">{{'Current-C' | translate}}</div>
                          <div class="value"><span>{{item.CurC}} {{'A' | translate}}</span></div>
                        </li>
                        <li>
                          <div class="title">{{'Peak Current' | translate}}</div>
                          <div class="value"><span *ngIf="(item.PkCur !== null && item.PkCur !== undefined) else noData_span">{{item.PkCur}} {{'A' | translate}}</span></div>
                        </li>
                        <li>
                          <div class="title">{{'Peak Current-A' | translate}}</div>
                          <div class="value"><span *ngIf="(item.PkCurA !== null && item.PkCurA !== undefined) else noData_span">{{item.PkCurA}} {{'A' | translate}}</span></div>
                        </li>
                        <li *ngIf="(item.PkCurB !== null && item.PkCurB !== undefined)">
                          <div class="title">{{'Peak Current-B' | translate}}</div>
                          <div class="value"><span>{{item.PkCurB}} {{'A' | translate}}</span></div>
                        </li>
                        <li *ngIf="(item.PkCurC !== null && item.PkCurC !== undefined)">
                          <div class="title">{{'Peak Current-C' | translate}}</div>
                          <div class="value"><span>{{item.PkCurC}} {{'A' | translate}}</span></div>
                        </li>
                        <!-- 收資料 但不顯示 2025/02/19 kyrie -->
                        <!-- <li *ngIf="item.PkTs">
                          <div translate class="title">Peak Time</div>
                          <div class="value"><span *ngIf="item.PkTs else noData_span">{{item.PkTs}}</span></div>
                        </li> -->
                        <li>
                          <div translate class="title">Voltage-A</div>
                          <div class="value"><span *ngIf="(item.VoltA !== null && item.VoltA !== undefined) else noData_span">{{item.VoltA}} {{'volts' | translate}}</span></div>
                        </li>
                        <li *ngIf="(item.VoltB !== null && item.VoltB !== undefined)">
                          <div translate class="title">Voltage-B</div>
                          <div class="value"><span>{{item.VoltB}} {{'volts' | translate}}</span></div>
                        </li>
                        <li *ngIf="(item.VoltC !== null && item.VoltC !== undefined)">
                          <div translate class="title">Voltage-C</div>
                          <div class="value"><span>{{item.VoltC}} {{'volts' | translate}}</span></div>
                        </li>
                        <li>
                          <div translate class="title">Energy</div>
                          <div class="value"><span *ngIf="(item.Energy !== null && item.Energy !== undefined) else noData_span">{{item.Energy}} {{'kWh' | translate}}</span></div>
                        </li>
                        <li *ngIf="(item.SelSrc !== null && item.SelSrc !== undefined)">
                          <div translate class="title">Selected Source</div>
                          <div class="value"><span>{{item.SelSrc | translate}}</span></div>
                        </li>
                        <li *ngIf="(item.PreSrc !== null && item.PreSrc !== undefined)">
                          <div translate class="title">Prefered Source</div>
                          <div class="value"><span>{{item.PreSrc | translate}}</span></div>
                        </li>
                        <li *ngIf="(item.SrcVoltA !== null && item.SrcVoltA !== undefined)">
                          <div translate class="title">Source Voltage-A</div>
                          <div class="value"><span>{{item.SrcVoltA}} {{'V' | translate}}</span></div>
                        </li>
                        <li *ngIf="(item.SrcVoltB !== null && item.SrcVoltB !== undefined)">
                          <div translate class="title">Source Voltage-B</div>
                          <div class="value"><span>{{item.SrcVoltB}} {{'V' | translate}}</span></div>
                        </li>
                        <li *ngIf="(item.SrcFreqA !== null && item.SrcFreqA !== undefined)">
                          <div translate class="title">Source Frequency-A</div>
                          <div class="value"><span>{{item.SrcFreqA}} {{'Hz' | translate}}</span></div>
                        </li>
                        <li *ngIf="(item.SrcFreqB !== null && item.SrcFreqB !== undefined)">
                          <div translate class="title">Source Frequency-B</div>
                          <div class="value"><span>{{item.SrcFreqB}} {{'Hz' | translate}}</span></div>
                        </li>
                        <li *ngIf="(item.SrcStaA !== null && item.SrcStaA !== undefined)">
                          <div translate class="title">Source Status-A</div>
                          <div class="value"><span>{{item.SrcStaA | translate}}</span></div>
                        </li>
                        <li *ngIf="(item.SrcStaB !== null && item.SrcStaB !== undefined)">
                          <div translate class="title">Source Status-B</div>
                          <div class="value"><span>{{item.SrcStaB | translate}}</span></div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <!-- Profile -->
                <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                  <div class="content-info">
                    <div class="content-title">
                      <h5 translate>Profile</h5>
                    </div>
                    <div class="content-body">
                      <ul class="info-list">
                        <li>
                          <div translate class="title">Device Name</div>
                          <div class="value">{{pageContentStatus.name}}</div>
                        </li>
                        <li>
                          <div translate class="title">Sub Device</div>
                          <div class="value">{{item.SubDevice}}</div>
                        </li>
                        <li>
                          <div translate class="title">Description</div>
                          <div class="value">{{pageContentStatus.deviceDescription}}</div>
                        </li>
                        <li>
                          <div translate class="title">Time Zone</div>
                          <div class="value"><span>{{pageContentStatus.region | utcFormat}}</span></div>
                        </li>
                        <li>
                          <div translate class="title">Model Name</div>
                          <div class="value">
                            <span *ngIf="item.Model else noData_span">{{item.Model}}</span>
                          </div>
                        </li>
                        <li class="serialNumber">
                          <div translate class="title">Serial Number</div>
                          <div class="value">
                            <span *ngIf="item.SN else noData_span">{{item.SN.substr(0, 25)}}</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </p-tabpanel>
          </p-tabs>
      </div>

      <!-- Energy Reporting -->
      <div *ngIf="energyInfoFeature" class="content-info">
        <div class="content-title">
          <h5 translate>Energy Reporting</h5>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="content-body statistic">
              <h6 translate>Statistic</h6>
              <ul class="info-list">
                <li class="date">
                  <div class="range">
                    <span class="dateLabel" translate>From</span>
                    <p-datepicker [(ngModel)]="energyRangeStart" [showIcon]="true" dateFormat="{{preferenceService.dateFormat}}"></p-datepicker>
                  </div>
                  <div class="range">
                    <span class="dateLabel toLabel" translate>to</span>
                    <p-datepicker [(ngModel)]="energyRangeEnd" [showIcon]="true" dateFormat="{{preferenceService.dateFormat}}"></p-datepicker>
                  </div>
                </li>
                <li>
                  <div class="title" translate>Averge Energy Consumption</div>
                  <div class="value">
                    {{reportingRange?.averageConsumption}} {{'Wh' | translate}}
                  </div>
                </li>
                <li>
                  <div class="title" translate>Cumulative Energy Consumption</div>
                  <div class="value">
                    {{reportingRange?.cumulativeConsumption}} {{'Wh' | translate}}
                  </div>
                </li>
                <li>
                  <div class="title" translate>Cumulative Cost</div>
                  <div class="value">
                    {{reportingRange?.cost}}
                  </div>
                </li>
                <li>
                  <div class="title">CO<span class="small">2</span> </div>
                  <div class="value">
                    {{reportingRange?.co2}} {{'Kg' | translate}}
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="content-body settings">
              <h6 translate>Settings</h6>
              <ul class="info-list">
                <li>
                  <div class="title" translate>Country</div>
                  <div class="value">
                    {{pageContentInfo?.countrySelection}}
                  </div>
                </li>
                <li>
                  <div class="title" translate>Cost per kWh</div>
                  <div class="value">
                    {{pageContentInfo?.energyCost}}
                  </div>
                </li>
                <li>
                  <div class="title">CO<span class="small">2</span> {{'Emitted per kWh' | translate}}</div>
                  <div class="value">
                    {{pageContentInfo?.co2Emitted}}
                  </div>
                </li>
                <li>
                  <div class="title">CO<span class="small">2</span> {{'Unit of Measurement' | translate}}</div>
                  <div class="value">
                    {{pageContentInfo?.unit}}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- Event Logs -->
      <div class="content-info evnets">
        <div class="content-title-table border-b-radius-none">
          <h5 translate>Event Logs</h5>
        </div>
        <!-- <p-dataTable [value]="eventLogs$ | async" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,20]">
          <p-column [sortable]="true" field="icon" header="Status" styleClass="text-center col-nowrap" [style]="{'width':'100px'}">
            <ng-template let-col let-data="rowData" pTemplate="body">
              <span class="center" *ngIf="!data.isHardwareFault">
                <i class="fa {{data.icon}} {{data.status}}" aria-hidden="true"></i>
              </span>
              <div class="icon errorCodeIcon" [ngStyle]="{'background-color': data.faultLevelColor}" *ngIf="data.isHardwareFault">
                <span>H</span>
              </div>
            </ng-template>
          </p-column>
          <p-column [sortable]="true" field="time" header="Time" [style]="{'width':'180px'}" styleClass="col-nowrap">
            <ng-template let-col let-item="rowData" pTemplate="body">
              {{(item.time != null) ? ((item.timestamp * 1000) + ((localTimeZone + item.timeZone)* 60 * 60 * 1000)  | date: 'yyyy/MM/dd HH:mm:ss') : ''}}
            </ng-template>
          </p-column>
          <p-column [sortable]="true" field="timezoneLabel" header="Time Zone" [style]="{'width':'120px'}"
                    styleClass="hidden-sm"></p-column>
          <p-column [sortable]="true" field="desc" header="Status Description" [style]="{'width':'100%'}"
                    styleClass="desc"></p-column>
        </p-dataTable> -->
        <div class="border-t-radius-none">
          <p-table class="deviceTable" #dt [columns]="eventLogs_cols" [value]="eventLogs$ | async" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,20]"
            [scrollable]="true">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
                  {{col.header | translate}}
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr>
                <td style="width: 100px" class="col-nowrap text-center">
                  <span class="center" *ngIf="!rowData.isHardwareFault">
                    <i class="fa {{rowData.icon}} {{rowData.status}}" aria-hidden="true"></i>
                  </span>
                  <div class="icon errorCodeIcon" *ngIf="rowData.isHardwareFault">
                    <!-- <span>H</span> -->
                    <i class="fa fa-exclamation-triangle" aria-hidden="true" [ngStyle]="{'color': rowData.faultLevelColor}"></i>
                  </div>
                </td>
                <td style="width: 180px" class="col-nowrap">
                  {{rowData.time}}
                </td>
                <td style="width: 120px" class="hidden-sm">{{rowData.timezoneLabel}}</td>
                <td style="width: 100%" class="desc">{{rowData.desc}}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="eventLogs_cols.length">
                  <div translate class="ui-emptymessage">No Event found</div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="{{'Device Settings' | translate}}" [(visible)]="display" (onHide)="resetField()" [modal]="true" [style]="{'width': '450px', 'min-width': '200px', 'top': '70px'}"
  [baseZIndex]="10000" class="settingsDialog">
  <p-tabs class="settings_tabView" (valueChange)="onTabChange($event)" [ngClass]="{'hideHeader': !energyInfoFeature }" value="0">
    <p-tablist>
        <p-tab value="0">{{'Device Profile' | translate}}</p-tab>
        <p-tab value="1" *ngIf="energyInfoFeature">{{'Energy Cost Settings' | translate}}</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <div class="dialog-content">
          <div class="form-group">
            <label translate>Device Name</label>
            <input type="text" size="30" class="form-control pInputText" [(ngModel)]="pageContentStatus.name" pInputText>
          </div>
          <div class="form-group">
            <label translate>Description</label>
            <input type="text" size="30" class="form-control pInputText" [(ngModel)]="pageContentStatus.deviceDescription" pInputText>
          </div>
          <div class="form-group" [ngClass]="{'type': RBRDChange}" *ngIf="pageContentStatus.subtype === 'UPS' || (pageContentStatus.subtype === '3-Phase UPS' && pageContentStatus.sourcetype !== SourceType['Gateway'])">
            <label translate>Battery Replacement Date / Device Initiation Date</label>
            <p-datepicker *ngIf="batteryReplacementInfo else noData_p" class="calendarDate" [ngModel]="batteryReplacementInfo.BR_Date_Format" (ngModelChange)="changeBtyReplacementDate($event)"
              [showIcon]="true" showButtonBar="true" [clearButtonStyleClass]="'clear-button'" dateFormat="{{preferenceService.dateFormat.replace('yyyy', 'yy').replace('MM', 'mm')}}"
              [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" appendTo="body">
            </p-datepicker>
          </div>
          <div class="form-group" *ngIf="(pageContentStatus.subtype === 'UPS' || (pageContentStatus.subtype === '3-Phase UPS' && pageContentStatus.sourcetype !== SourceType['Gateway'])) && RBRDChange" >
            <div class="check">
              <p-checkbox value="true" label="{{'I actually replaced battery' | translate}}" (onChange)="checkBtyReplace($event)"></p-checkbox>
            </div>
          </div>
          <div class="form-group" *ngIf="(pageContentStatus.subtype === 'UPS' || (pageContentStatus.subtype === '3-Phase UPS' && pageContentStatus.sourcetype !== SourceType['Gateway'])) && batteryLife">
            <label translate>Recommended Battery Replacement Cycle</label>
            <div class="select">
              <p-select [options]="batteryLifeOptions" [(ngModel)]="batteryReplacementInfo.BR_Months" (ngModelChange)="changeBatteryLife($event)" appendTo="body"></p-select>
            </div>
          </div>
          <div class="form-group" *ngIf="pageContentStatus.subtype === 'UPS' || (pageContentStatus.subtype === '3-Phase UPS' && pageContentStatus.sourcetype !== SourceType['Gateway'])">
            <label translate>Recommended Battery Replacement Date</label>
            <p *ngIf="batteryReplacementInfo && batteryReplacementInfo.BR_Date else noData_p">
              {{(pageContentStatus.region)* 60 * 60 * 1000 + batteryReplacementInfo.BR_Rc_Date | date: preferenceService.dateFormat}}</p>
          </div>

          <div class="form-group">
            <label translate>Time Zone</label>
            <div class="select">
              <p-select [options]="timezoneOptions" [(ngModel)]="pageContentStatus.region" [disabled]="pageContentStatus.gId !== null" appendTo="body"></p-select>
              <p-message severity="error" text="{{'Please select time zone.' | translate}}" *ngIf="timezoneErrors && this.pageContentStatus.region == null"></p-message>
            </div>
          </div>
        </div>
      </p-tabpanel>
      <p-tabpanel *ngIf="energyInfoFeature" value="1">
        <div class="dialog-content">
          <div class="form-group">
            <label translate>Country</label>
            <div class="select">
              <p-select [options]="unitOptions"></p-select>
            </div>
          </div>
          <div class="form-group">
            <label translate>Cost per kWh</label>
            <div class="select">
              <input type="text" size="30" class="form-control pInputText" pInputText>
            </div>
          </div>
          <div class="form-group">
            <label>CO<span class="small">2</span> {{'Emitted per kWh' | translate}}</label>
            <div class="select">
              <input type="text" size="30" class="form-control pInputText" pInputText>
            </div>
          </div>
          <div class="form-group">
            <label>CO<span class="small">2</span> {{'Measure Unit' | translate}}</label>
            <div class="select">
              <p-select [options]="unitOptions"></p-select>
            </div>
          </div>
        </div>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
  <ng-template #footer>
    <button type="button" pButton (click)="updateDeviceInfo()" label="{{'Save' | translate}}" class="{{Confirm_button}}" [hidden]="indexNum == 1"></button>
    <button type="button" pButton label="Save" class="{{Confirm_button}}" [hidden]="indexNum == 0"></button>
    <button type="button" pButton (click)="display=false;" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<p-dialog header="{{'BHI Settings' | translate}}" [(visible)]="displayBHI" (onHide)="resetField()" [modal]="true" [style]="{'width': '450px', 'min-width': '200px', 'top': '70px'}"
  [baseZIndex]="10000" class="settingsDialog">
  <div class="form-group">
    <label translate>Device Initiation Date</label>
    <p-datepicker *ngIf="batteryReplacementInfo else noData_p" class="calendarDate" [ngModel]="batteryReplacementInfo.BR_Date_Format" (ngModelChange)="changeBtyReplacementDate($event)"
      [showIcon]="true" showButtonBar="true" [clearButtonStyleClass]="'clear-button'" dateFormat="{{preferenceService.dateFormat.replace('yyyy', 'yy').replace('MM', 'mm')}}" [monthNavigator]="true"
      [yearNavigator]="true" yearRange="2000:2030" appendTo="body">
    </p-datepicker>
  </div>
  <div class="form-group" style="display: none;">
    <label translate>Recommended Battery Replacement Date</label>
    <p *ngIf="batteryReplacementInfo && batteryReplacementInfo.BR_Date else noData_p">
      {{(pageContentStatus.region)* 60 * 60 * 1000 + batteryReplacementInfo.BR_Rc_Date | date: preferenceService.dateFormat}}</p>
  </div>
  <div class="form-group" style="display: none;">
    <label translate>Time Zone</label>
    <div class="select">
      <p-select [options]="timezoneOptions" [(ngModel)]="pageContentStatus.region" [disabled]="pageContentStatus.gId !== null" appendTo="body"></p-select>
      <p-message severity="error" text="{{'Please select time zone.' | translate}}" *ngIf="timezoneErrors && this.pageContentStatus.region == null"></p-message>
    </div>
  </div>
  <div translate class="alert alert-warning">
    Please input your Device Initiation Date to activate BHI.
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="confirm_BHI=true" label="{{'Save' | translate}}" class="{{Confirm_button}}"></button>
    <button type="button" pButton (click)="displayBHI=false;" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<p-dialog header="{{'Attention' | translate}}" [(visible)]="confirm_BHI" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <h5 translate>The date is confirmed, which will be used for BHI</h5>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="updateDeviceInitiationDate();" class="{{Confirm_button}}"></button>
    <button type="button" pButton label="{{'Cancel' | translate}}" (click)="confirm_BHI=false" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<p-dialog header="{{'Outlet Naming' | translate}}" [(visible)]="outletNamingDialog" (onHide)="resetField()" [modal]="true" [style]="{'width': '600px', 'min-width': '200px', 'top': '70px'}"
  [baseZIndex]="10000" class="accountSetting outletNaming">
  <div class="dialog-content">
    <div class="flex wrap">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">{{'Outlet' | translate}} 1</span>
        <input type="text" size="30" class="form-control pInputText" [(ngModel)]="outletNamingDialogInput.outlet1" pInputText>
      </div>
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">{{'Outlet' | translate}} 2</span>
        <input type="text" size="30" class="form-control pInputText" [(ngModel)]="outletNamingDialogInput.outlet2" pInputText>
      </div>
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">{{'Outlet' | translate}} 3</span>
        <input type="text" size="30" class="form-control pInputText" [(ngModel)]="outletNamingDialogInput.outlet3" pInputText>
      </div>
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">{{'Outlet' | translate}} 4</span>
        <input type="text" size="30" class="form-control pInputText" [(ngModel)]="outletNamingDialogInput.outlet4" pInputText>
      </div>
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">{{'Outlet' | translate}} 5</span>
        <input type="text" size="30" class="form-control pInputText" [(ngModel)]="outletNamingDialogInput.outlet5" pInputText>
      </div>
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">{{'Outlet' | translate}} 6</span>
        <input type="text" size="30" class="form-control pInputText" [(ngModel)]="outletNamingDialogInput.outlet6" pInputText>
      </div>
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">{{'Outlet' | translate}} 7</span>
        <input type="text" size="30" class="form-control pInputText" [(ngModel)]="outletNamingDialogInput.outlet7" pInputText>
      </div>
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">{{'Outlet' | translate}} 8</span>
        <input type="text" size="30" class="form-control pInputText" [(ngModel)]="outletNamingDialogInput.outlet8" pInputText>
      </div>
    </div>

    <p-accordion class="more-accordion">
      <p-accordion-panel value="0">
          <p-accordion-header>more..</p-accordion-header>
          <p-accordion-content>
            <div class="flex wrap">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">{{'Outlet' | translate}} 9</span>
                <input type="text" size="30" class="form-control pInputText" [(ngModel)]="outletNamingDialogInput.outlet9" pInputText>
              </div>
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">{{'Outlet' | translate}} 10</span>
                <input type="text" size="30" class="form-control pInputText" [(ngModel)]="outletNamingDialogInput.outlet10" pInputText>
              </div>
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">{{'Outlet' | translate}} 11</span>
                <input type="text" size="30" class="form-control pInputText" [(ngModel)]="outletNamingDialogInput.outlet11" pInputText>
              </div>
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">{{'Outlet' | translate}} 12</span>
                <input type="text" size="30" class="form-control pInputText" [(ngModel)]="outletNamingDialogInput.outlet12" pInputText>
              </div>
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">{{'Outlet' | translate}} 13</span>
                <input type="text" size="30" class="form-control pInputText" [(ngModel)]="outletNamingDialogInput.outlet13" pInputText>
              </div>
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">{{'Outlet' | translate}} 14</span>
                <input type="text" size="30" class="form-control pInputText" [(ngModel)]="outletNamingDialogInput.outlet14" pInputText>
              </div>
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">{{'Outlet' | translate}} 15</span>
                <input type="text" size="30" class="form-control pInputText" [(ngModel)]="outletNamingDialogInput.outlet15" pInputText>
              </div>
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">{{'Outlet' | translate}} 16</span>
                <input type="text" size="30" class="form-control pInputText" [(ngModel)]="outletNamingDialogInput.outlet16" pInputText>
              </div>
            </div>
          </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="saveOutletNaming();" label="{{'Save' | translate}}" class="{{Confirm_button}}" [disabled]="disableOutletSave"></button>
    <button type="button" pButton (click)="outletNamingDialog=false;" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<p-toast [style]="{ marginTop: '70px'}"></p-toast>

<app-dialog (connectEvtAddOtp)="switchUpsControl($event);" (connectEvt)="confrimUpsControlCode($event);"></app-dialog>

<ng-template #noData_p>
  <p>--</p>
</ng-template>
<ng-template #noData_span>
  <span>--</span>
</ng-template>
<ng-template #Inactivate>
  <button type="button" pButton (click)="showBHIDisplayDialog();" label="{{'Activate BHI' | translate}}" class="{{Confirm_button}}" [disabled]="pageContentStatus.status === 'offline' || pageContentStatus.is_shared || disableBHI"></button>
</ng-template>
<p-popover #BHI class="infoPanel batteryHealth" [style]="{ 'max-width': '400px' }">
  <div>
    <ol>
      <li translate>
        Battery Health Indicator represents the estimated health status of your UPS battery.
      </li>
      <li translate>
        Battery life is heavily affected by level of discharges and time. The actual battery life is always subject to how UPS has been utilized.
      </li>
      <li translate class="strong" *ngIf="!isBHIActivated">
        Please click Activate BHI to diagnose your device.
      </li>
    </ol>
  </div>
</p-popover>
